module.exports = __webpack_public_path__ + "media/MRI1.47669aad.mp3";